import { ConfirmDialog } from 'primereact/confirmdialog';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Button } from 'primereact/button';

const AutoLogoutModal = ({ onHide, showHide, confirmLogout, resetLogoutTimeout }) => {
	const hideModal = () => {
		onHide();
		confirmLogout();
	};

  const acceptLabel = (
    <div style={{ color: 'white' }}>
      <FontAwesomeIcon icon={faCheck} />&nbsp; Yes
    </div>
  );

  const rejectLabel = (
    <div>
      <FontAwesomeIcon icon={faXmark} />&nbsp; No
    </div>
  );

	const message = (
		<>
			Your session will be ended soon, please confirm to continue.
			<br /> Click no to direct logout.
		</>
	);

	return (
		<>
			<ConfirmDialog
      group="headless"
      visible={showHide}
      onHide={onHide}
      closable={false}
      content={({ headerRef, contentRef, footerRef, hide }) => (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '2rem',
            backgroundColor: '#fff',
            borderRadius: '12px',
            boxShadow: '0 0 10px rgba(0,0,0,0.15)',
            textAlign: 'center',
          }}
        >
          <div
            style={{
              backgroundColor: '#d40b0b',
              color: 'white',
              width: '106px',
              height: '106px',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '-78px',
              fontSize: '3rem',
            }}
          >
            <i className="pi pi-exclamation-triangle" style={{ fontSize: '2.5rem' }} />
          </div>

          <div ref={headerRef} style={{ fontSize: '1.5rem', fontWeight: 'bold', marginTop: '1rem' }}>
            Warning
          </div>
          <p ref={contentRef} style={{ marginTop: '1rem', fontSize: '1rem' }}>
            {message}
          </p>
          <div ref={footerRef} style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
            <Button
							id="btnCancel"
              label={rejectLabel}
              outlined
              style={{ width: '6rem' }}
              onClick={(e) => {
                hide(e);
								hideModal()
              }}
            />
            <Button
							id="btnConfirm"
              label={acceptLabel}
              className="p-button-danger"
              style={{ border: 'none', width: '6rem' }}
              onClick={(e) => {
                hide(e);
              }}
            />
          </div>
        </div>
      )}
      className="custom-confirm-dialog"
    />
		</>
	);
}

export default AutoLogoutModal;